import React, { useState, useEffect } from 'react'
import { Carousel } from 'react-bootstrap'

import { apiHandler } from '../api/apihandler';
import { FEEDS_LIST } from "../api/constants";

function normalizeAnnouncementContent(value) {
    if (!value) {
        return '';
    }

    if (typeof value !== 'string') {
        return String(value);
    }

    const trimmedValue = value.trim();

    try {
        const parsedValue = JSON.parse(trimmedValue);
        return typeof parsedValue === 'string' ? parsedValue : trimmedValue;
    } catch (error) {
        return trimmedValue.replace(/^"|"$/g, '');
    }
}

function formatAnnouncementDate(value) {
    if (!value) {
        return 'Latest update';
    }

    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
        return 'Latest update';
    }

    return parsedDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

function getAnnouncementImage(announcement) {
    const firstImage = Array.isArray(announcement?.user_post_images)
        ? announcement.user_post_images[0]
        : null;

    return firstImage?.image_path || '';
}

function renderAnnouncementSlide(announcement, isSingleAnnouncement = false, showAuthorMeta = true) {
    const imageUrl = getAnnouncementImage(announcement);
    const content = normalizeAnnouncementContent(announcement?.content);
    const authorName = [announcement?.user?.first_name, announcement?.user?.last_name]
        .filter(Boolean)
        .join(' ')
        .trim() || 'Daycare update';
    const commentCount = Number(announcement?.comment_count || 0);
    const likeCount = Number(announcement?.like_count || 0);

    return (
        <div
            className="announcement-card-shell"
            style={{
                display: 'grid',
                gridTemplateColumns: imageUrl ? 'minmax(0, 1fr) 180px' : 'minmax(0, 1fr)',
                gap: '14px',
                alignItems: 'stretch',
            }}
        >
            <div style={{ minWidth: 0 }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '10px',
                        flexWrap: 'wrap',
                        marginBottom: '10px',
                    }}
                >
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '6px 12px',
                            borderRadius: '10px',
                            background: 'rgba(255,255,255,0.12)',
                            border: '1px solid rgba(255,255,255,0.18)',
                            color: '#fff',
                            fontSize: '11px',
                            fontWeight: 700,
                            letterSpacing: '0.02em',
                            textTransform: 'uppercase',
                        }}
                    >
                        <span
                            style={{
                                display: 'inline-flex',
                                width: '22px',
                                height: '22px',
                                borderRadius: '7px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(255,255,255,0.18)',
                                fontSize: '12px',
                            }}
                        >
                            i
                        </span>
                        School Announcement
                    </div>

                    <div
                        style={{
                            color: 'rgba(255,255,255,0.8)',
                            fontSize: '11px',
                            fontWeight: 600,
                        }}
                    >
                        {formatAnnouncementDate(announcement?.created_at)}
                    </div>
                </div>

                <div
                    style={{
                        color: '#ffffff',
                        fontSize: isSingleAnnouncement ? '14px' : '13px',
                        lineHeight: 1.45,
                        fontWeight: 600,
                        marginBottom: '12px',
                        maxWidth: '900px',
                    }}
                >
                    {content}
                </div>

                {showAuthorMeta ? (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            flexWrap: 'wrap',
                        }}
                    >
                        <div
                            style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '10px',
                                background: 'linear-gradient(135deg, rgba(255,255,255,0.32), rgba(255,255,255,0.16))',
                                border: '1px solid rgba(255,255,255,0.22)',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '12px',
                                flexShrink: 0,
                            }}
                        >
                            {authorName.slice(0, 2).toUpperCase()}
                        </div>

                        <div style={{ minWidth: 0 }}>
                            <div style={{ color: '#fff', fontSize: '12px', fontWeight: 700 }}>
                                {authorName}
                            </div>
                            <div style={{ color: 'rgba(255,255,255,0.72)', fontSize: '10px' }}>
                                {likeCount} likes · {commentCount} comments
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>

            {imageUrl ? (
                <div
                    className="announcement-media-shell"
                    style={{
                        minHeight: '120px',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        border: '1px solid rgba(255,255,255,0.18)',
                        boxShadow: '0 14px 30px rgba(20, 10, 48, 0.22)',
                        background: 'rgba(255,255,255,0.08)',
                    }}
                >
                    <img
                        src={imageUrl}
                        alt="Announcement"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />
                </div>
            ) : null}
        </div>
    );
}


const Announcement = ({
    maxWidth = null,
    outerPadding = '12px 18px 6px',
    showAuthorMeta = true,
    showCloseButton = false,
}) => {
    const [announcementsList, setAnnouncementsList] = useState([]);
    const [isDismissed, setIsDismissed] = useState(false);
    useEffect(() => {
        getAnnoucementApi()
    }, [])

    async function getAnnoucementApi() {
        try {
            const res = await apiHandler(FEEDS_LIST, "POST", {
                type: 6,
                page: 1,
                limit: 10,
            })
            if (res.data?.response?.status === 200) {
                setAnnouncementsList(res?.data?.data?.feeds?.data || [])
            }
        } catch (error) {
            console.error(error);
        }
        finally {
        }
    }

    // Don't render if no announcements
    if (isDismissed || !announcementsList || announcementsList.length === 0) {
        return null;
    }

    return (
        <div
            style={{
                padding: outerPadding,
            }}
        >
            <style>{`
                .announcement-banner {
                    position: relative;
                    overflow: hidden;
                    border-radius: 12px;
                    background:
                        radial-gradient(circle at top right, rgba(255, 198, 92, 0.18), transparent 30%),
                        radial-gradient(circle at bottom left, rgba(255, 255, 255, 0.10), transparent 28%),
                        linear-gradient(135deg, #4b1f75 0%, #6f3397 52%, #3c195d 100%);
                    box-shadow: 0 24px 48px rgba(47, 18, 77, 0.20);
                    border: 1px solid rgba(93, 45, 130, 0.14);
                }

                .announcement-banner::before {
                    content: '';
                    position: absolute;
                    inset: auto -60px -60px auto;
                    width: 180px;
                    height: 180px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.06);
                }

                .announcement-banner::after {
                    content: '';
                    position: absolute;
                    inset: 18px auto auto 22px;
                    width: 110px;
                    height: 110px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.04);
                    filter: blur(2px);
                }

                .announcement-banner-inner {
                    position: relative;
                    z-index: 1;
                    padding: 18px 22px;
                }

                .announcement-close-btn {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    width: 30px;
                    height: 30px;
                    border: 1px solid rgba(255, 255, 255, 0.18);
                    border-radius: 9px;
                    background: rgba(255, 255, 255, 0.14);
                    color: #ffffff;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    line-height: 1;
                    cursor: pointer;
                    transition: background-color 0.2s ease, border-color 0.2s ease;
                    z-index: 3;
                }

                .announcement-close-btn:hover {
                    background: rgba(255, 255, 255, 0.22);
                    border-color: rgba(255, 255, 255, 0.28);
                }

                .announcement-close-btn:focus {
                    outline: 2px solid rgba(255, 255, 255, 0.42);
                    outline-offset: 1px;
                }

                .announcement-carousel .carousel-control-prev,
                .announcement-carousel .carousel-control-next {
                    width: 34px;
                    height: 34px;
                    top: 18px;
                    bottom: auto;
                    opacity: 1;
                    border-radius: 10px;
                    background: rgba(255, 255, 255, 0.14);
                    border: 1px solid rgba(255,255,255,0.16);
                    backdrop-filter: blur(10px);
                }

                .announcement-carousel .carousel-control-prev {
                    left: auto;
                    right: 52px;
                }

                .announcement-carousel .carousel-control-next {
                    right: 0;
                }

                .announcement-banner.is-dismissible .announcement-carousel .carousel-control-next {
                    right: 40px;
                }

                .announcement-banner.is-dismissible .announcement-carousel .carousel-control-prev {
                    right: 92px;
                }

                .announcement-carousel .carousel-control-prev-icon,
                .announcement-carousel .carousel-control-next-icon {
                    width: 13px;
                    height: 13px;
                }

                .announcement-carousel .carousel-item {
                    padding-top: 2px;
                }

                @media (max-width: 991px) {
                    .announcement-card-shell {
                        grid-template-columns: minmax(0, 1fr) !important;
                    }

                    .announcement-media-shell {
                        max-width: 100%;
                        min-height: 160px !important;
                    }
                }

                @media (max-width: 767px) {
                    .announcement-banner-inner {
                        padding: 16px 16px;
                    }

                    .announcement-carousel .carousel-control-prev,
                    .announcement-carousel .carousel-control-next {
                        top: 14px;
                        width: 30px;
                        height: 30px;
                    }

                    .announcement-carousel .carousel-control-prev {
                        right: 44px;
                    }

                    .announcement-banner.is-dismissible .announcement-carousel .carousel-control-next {
                        right: 38px;
                    }

                    .announcement-banner.is-dismissible .announcement-carousel .carousel-control-prev {
                        right: 82px;
                    }

                    .announcement-close-btn {
                        top: 10px;
                        right: 10px;
                        width: 28px;
                        height: 28px;
                        font-size: 16px;
                    }
                }
            `}</style>

            <div
                className={`announcement-banner${showCloseButton ? ' is-dismissible' : ''}`}
                style={{
                    maxWidth: maxWidth || undefined,
                    margin: '0 auto',
                }}
            >
                {showCloseButton ? (
                    <button
                        type="button"
                        className="announcement-close-btn"
                        aria-label="Close announcement"
                        onClick={() => setIsDismissed(true)}
                    >
                        ×
                    </button>
                ) : null}
                <div className="announcement-banner-inner">
                    {announcementsList.length === 1 ? (
                        renderAnnouncementSlide(announcementsList[0], true, showAuthorMeta)
                    ) : (
                        <Carousel
                            className="announcement-carousel"
                            indicators={false}
                            controls={announcementsList.length > 1}
                            interval={5000}
                            pause="hover"
                            nextIcon={<span className="carousel-control-next-icon" style={{ filter: 'invert(1)' }} />}
                            prevIcon={<span className="carousel-control-prev-icon" style={{ filter: 'invert(1)' }} />}
                        >
                            {announcementsList.map((announcement, index) => (
                                <Carousel.Item key={announcement.id || index}>
                                    {renderAnnouncementSlide(announcement, false, showAuthorMeta)}
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Announcement
